<template lang="pug">
  
MDashboardWidget( title="Filtered Enterprise Report" )

  p Download data from multiple batches in one Enterprise Report
  
  div( class="form-group row" )
    div( class="col-sm-10" )

      p Filter by audits run between:
      small Capped at 3 months

      p( class="d-flex" )
        label( class="mr-4" ) Start Date:
          input( type="date" class="form-control" v-model="startDate" )

        label End Date:
          input( type="date" class="form-control" v-model="endDate" )
      
      p
        label Filter by country code(s):
        em (Ctrl/Cmd + click to select multiple)
        MCountryCodeSelector( v-model="selectedCountryCodes" multiple )
      
      p( v-if="$moonpull.currentUserIsSuperAdmin()" )
        label Comapny Selector
        MCompanySelector( v-on:input="onCompanyInput" label="Select Company:" )
      
      p( class="text-left mt-2" )
        button( class="btn btn-details btn-outline btn-info mr-2" v-bind:disabled="loading" v-on:click="generateCSV('publisher')" )
          i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
          | Download CSV(Publisher)
      
      div( class="progress" v-if="loading" )
        div(
          class="progress-bar progress-bar-striped progress-bar-animated"
          role="progressbar"
          aria-valuemin="0"
          aria-valuemax="100"
          v-bind:class="{ 'progress-bar-success': progressPercent < 100, 'progress-bar-primary': progressPercent >= 100 }"
          v-bind:style="`width: ${progressPercent}%;`"
          v-bind:aria-valuenow="progressPercent"
        )
      
      p( class="text-danger m-0" v-if="errorMessage" ) {{ errorMessage }}

</template>

<style lang="scss" scoped></style>

<script>
import gql from "graphql-tag";
import Vue from "vue";
import { flashMessage } from "@/store/index";
import { countryCodes } from "@/countryCodes";
import dateFormat from "dateformat";
export default Vue.extend({
  data() {
    return {
      countryCodes,
      selectedCountryCodes: null,
      startDate: null,
      endDate: null,
      loading: false,
      errorMessage: "",
      progressPercent: 0,
      spoofLoadingHandle: null,
      companyId,
    };
  },

  methods: {
    spoofLoading() {
      // Loading will take roughly 30s regardless of data range
      const interval = 30000 / 100;
      let increment = 1.0;
      this.spoofLoadingHandle = setInterval(() => {
        this.progressPercent += increment;
        if (this.progressPercent >= 90) {
          increment = 0.5;
        } else if (this.progressPercent >= 95) {
          increment = 0.1;
        } else if (this.progressPercent >= 98) {
          clearInterval(this.spoofLoadingHandle);
          this.spoofLoadingHandle = null;
        }
      }, interval);
    },

    isDateRangeValid() {
      if (!this.endDate || !this.startDate) {
        return false;
      }

      const endDateObj = new Date(this.endDate);
      const startDateObj = new Date(this.startDate);

      console.log(`endDate`, this.endDate, endDateObj);
      console.log(`startDate`, this.startDate, startDateObj);

      // Dates must be valid
      if (
        endDateObj.toString() === "Invalid Date" ||
        startDateObj.toString() === "Invalid Date"
      ) {
        return false;
      }

      // Start must be before end
      if (endDateObj < startDateObj) {
        return false;
      }

      // Date range must be no longer than 90 days
      return (
        new Date(this.endDate) - new Date(this.startDate) <=
        1000 * 60 * 60 * 24 * 365
      );
    },

    onCompanyInput(e) {
      this.companyId = e;
    },

    async generateCSV(type) {
      console.log(`validdate`, this.isDateRangeValid());
      if (!this.isDateRangeValid()) {
        flashMessage("warning", "Invalid date range");
        this.errorMessage = "Invalid date range";
        return;
      }
      this.errorMessage = null;

      try {
        this.loading = true;
        this.spoofLoading();

        const {
          data: { generateFilteredEnterpriseReport },
        } = await this.$apollo.query({
          query: gql`
            query GenerateFilteredEnterpriseReport(
              $startDate: DateTime!
              $endDate: DateTime!
              $countryCodes: [String!]
              $companyId: ID
              $type: String!
            ) {
              generateFilteredEnterpriseReport(
                startDate: $startDate
                endDate: $endDate
                countryCodes: $countryCodes
                companyId: $companyId
                type: $type
              )
            }
          `,
          variables: {
            startDate: this.startDate,
            endDate: this.endDate,
            countryCodes: this.selectedCountryCodes,
            companyId: this.companyId,
            type,
          },
        });

        this.progressPercent = 100;

        const a = document.createElement("a");
        document.body.appendChild(a);
        a.setAttribute("style", "display:none");
        const blob = new Blob([generateFilteredEnterpriseReport], {
          type: "octet/stream",
        });
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download =
          `Moonpull Report ${dateFormat(
            this.startDate,
            "dd mmm"
          )} to ${dateFormat(this.endDate, "dd mmm")}` +
          (this.selectedCountryCodes?.length
            ? ` ${this.selectedCountryCodes.join(", ")}`
            : "") +
          `.csv`;
        console.log(a.download);
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        flashMessage(
          "danger",
          "An unexpected error occurred. Please try again later."
        );
        console.error(e);
      }

      clearInterval(this.spoofLoadingHandle);
      this.spoofLoadingHandle = null;

      // Add slight delay so user can see the full success bar
      setInterval(() => {
        this.loading = false;
        this.progressPercent = 0;
      }, 1500);
    },
  },
});
</script>
